import * as actionTypes from '../constants/actionType';
import * as apiActions from './apiActions';
import * as apiValues from '../constants/apiValues';


//Action Creators
export const loadMNewsDetailStart = () => {
  return {
    type: actionTypes.MNEWSDETAIL_LOAD_START,
  };
};
export const loadMNewsDetailFail = (error) => {
  console.error(error);
  return {
    type: actionTypes.MNEWSDETAIL_LOAD_FAIL,
    error,
  };
};
export const loadMNewsDetailSuccess = (data) => {
  return {
    type: actionTypes.MNEWSDETAIL_LOAD_SUCCESS,
    data,
  };
};

function normalizeNewsDetail(result) {
  const news = apiActions.itemSelectCamelCaseKeys(result, apiValues.nref.news.fieldsUsed);
  news.tags = apiActions.arraySelectCamelCaseKeys(news.tags, apiValues.nref.tag.fieldsUsed);
  return { news };
}

function loadNewsBySlugOrId(slugOrId) {
  return apiActions.loadEndpoint(apiValues.nref.news.endpoint, null, { Slug: slugOrId })
    .then((results) => {
      if (Array.isArray(results) && results.length > 0) {
        return results[0];
      }
      const documentId = apiActions.resolveDocumentId(slugOrId);
      if (!documentId) {
        return null;
      }
      return apiActions.loadEndpoint(apiValues.nref.news.endpoint, documentId).then((result) => {
        if (Array.isArray(result)) {
          return result[0] || null;
        }
        return result || null;
      });
    });
}

export const initMNewsDetail = slugOrId => dispatch => {
  dispatch(loadMNewsDetailStart());

  return loadNewsBySlugOrId(slugOrId)
    .then((result) => {
      if (!result) {
        throw new Error(`News not found: ${slugOrId}`);
      }
      return dispatch(loadMNewsDetailSuccess(normalizeNewsDetail(result)));
    })
    .catch((error) => {
      dispatch(loadMNewsDetailFail(error));
      throw error;
    });
};
